import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import SearchModal from '../../components/feature/SearchModal';

export default function AboutPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const { totalItems: wishlistTotal } = useWishlist();
  const { totalItems } = useCart();

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile: Hamburger on left */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>

          {/* Logo in center */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-line text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/hoodies" className="block text-sm tracking-[0.15em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/tees" className="block text-sm tracking-[0.15em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.15em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-shopping-bag-line text-xl"></i>
                  {totalItems > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {totalItems}
                    </span>
                  )}
                </Link>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-line text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <div className="relative h-screen mt-[73px]">
        <img 
          src="https://public.readdy.ai/ai/img_res/b9cb469d7ce7153dd630e0366bf27645.jpg"
          alt="About VERBUM"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-3xl px-6">
            <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-light tracking-[0.15em] md:tracking-[0.2em] lg:tracking-[0.3em] mb-4 md:mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              ABOUT DASHY
            </h1>
            <p className="text-sm sm:text-base md:text-lg tracking-[0.1em] md:tracking-[0.15em] lg:tracking-[0.2em] font-light">
              WHERE WORDS MEET LUXURY
            </p>
          </div>
        </div>
      </div>

      {/* Our Story */}
      <section className="py-20 md:py-32 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] text-center mb-8 md:mb-12" style={{ fontFamily: '"Playfair Display", serif' }}>
            OUR STORY
          </h2>
          <div className="space-y-6 md:space-y-8 text-base md:text-lg leading-relaxed text-neutral-700">
            <p>
              At DASHY, our mission is to inspire individuals to express their unique identities through bold and stylish apparel. We are committed to creating high-quality clothing infused with quiet luxury that bridges the gap between fashion and life, fostering self-expression. 
            </p>
            <p>
              DASHY positions itself as a vibrant and bold clothing brand that empowers individuals to express their unique identities through stylish and comfortable apparel. Targeting fashion-forward individuals who aspire to break free from the ordinary, DASHY merges creativity and quality to provide pieces that not only make a statement but also convey messages on behalf of everyone in everyday life.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-32 px-6 bg-black text-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] text-center mb-12 md:mb-20" style={{ fontFamily: '"Playfair Display", serif' }}>
            OUR VALUES
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center border border-white/20">
                <i className="ri-leaf-line text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl tracking-[0.15em] md:tracking-[0.2em] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                SUSTAINABILITY
              </h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                100% organic cotton, ethical manufacturing, and minimal environmental impact. We believe luxury should never come at the planet's expense.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center border border-white/20">
                <i className="ri-hand-heart-line text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl tracking-[0.15em] md:tracking-[0.2em] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                CRAFTSMANSHIP
              </h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                Every stitch, every print, every detail is executed with precision. We partner with artisans who share our commitment to excellence.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center border border-white/20">
                <i className="ri-book-open-line text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl tracking-[0.15em] md:tracking-[0.2em] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                MEANING
              </h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                Words have power. Each quote is chosen for its depth, relevance, and ability to inspire reflection in our fast-paced world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Craftsmanship */}
      <section className="py-20 md:py-32 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20premium%20black%20cotton%20fabric%20texture%20with%20elegant%20typography%20being%20screen%20printed%20by%20hand%20artisan%20craftsmanship%20luxury%20garment%20production%20process%20emphasizing%20quality%20and%20precision%20minimalist%20aesthetic%20professional%20photography&width=800&height=1000&seq=craft1&orientation=portrait"
                alt="Craftsmanship"
                className="w-full h-auto"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] mb-6 md:mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>
                CRAFTED WITH CARE
              </h2>
              <div className="space-y-4 md:space-y-6 text-sm md:text-base text-neutral-700">
                <p>
                  Our garments begin with the finest 100% organic cotton, sourced from certified sustainable farms. The fabric is pre-washed and pre-shrunk to ensure longevity and the perfect fit from the first wear.
                </p>
                <p>
                  Each piece is cut and sewn by skilled artisans who have honed their craft over decades. The typography is screen-printed using eco-friendly, water-based inks that won't crack or fade, ensuring your message remains as clear as the day you bought it.
                </p>
                <p>
                  We produce in small batches to maintain quality control and minimize waste. Every hoodie and tee undergoes rigorous inspection before it reaches you, because we believe in delivering nothing less than perfection.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-32 px-6 bg-neutral-50">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] mb-6 md:mb-8" style={{ fontFamily: '"Playfair Display", serif' }}>
            JOIN THE MOVEMENT
          </h2>
          <p className="text-base md:text-lg text-neutral-700 mb-8 md:mb-12 leading-relaxed">
            Discover pieces that speak to who you are and who you aspire to be. Explore our collection and find the words that resonate with your journey.
          </p>
          <Link 
            to="/shop"
            className="inline-block px-8 md:px-12 py-3 md:py-4 border border-black text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] hover:bg-black hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            EXPLORE COLLECTION
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 md:py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-4 md:mb-6">DASHY</h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">SHOP</h4>
              <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">COMPANY</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-6 md:pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-xs md:text-sm text-neutral-400">
            <div className="flex items-center gap-3">
              <p className="text-center md:text-left">© 2024 DASHY FASHION LIMITED. All rights reserved.</p>
            </div>
            <div className="flex gap-4 md:gap-6">
              <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
